/* eslint-disable */
import Vue from 'vue';
import weuijs from 'weui.js';
import wx from 'weixin-js-sdk';
import axios from 'axios';
import Cookie from './core/cookie';

const utils = {
  ...weuijs,
  Cookie,
  Array: {
    findIndex(array, value, key, startIndex) {
      let index = -1;

      for (let i = startIndex || 0; i < array.length; i += 1) {
        const item = array[i];
        if (key && item[key] === value[key]) {
          index = i;
          break;
        } else if (item === value) {
          index = i;
          break;
        }
      }

      return index;
    },
    exist(array, value, key) {
      const index = this.findIndex(array, value, key);

      return index !== -1;
    },
    existArray(array, part, key) {
      let isAll = true;
      if (part) {
        for (let i = 0; i < part.length; i += 1) {
          const value = part[i];
          if (!this.exist(array, value, key)) {
            isAll = false;
            break;
          }
        }
      }
      return part && part.length && isAll;
    },
    find(array, value, key) {
      const index = this.findIndex(array, value, key);

      if (index !== -1) {
        return array[index];
      } else {
        return undefined;
      }
    },
    unipush(array, value, key) {
      if (!this.exist(array, value, key)) {
        array.push(value);
      }
    },
    pushReplace(array, value, key) {
      if (this.exist(array, value, key)) {
        this.remove(array, value, key)
      }
      array.push(value);
    },
    remove(array, value, key) {
      const index = this.findIndex(array, value, key);

      if (index !== -1) {
        array.splice(index, 1);
      }
    },
    removeAll(array, value, key, startIndex) {
      let index;
      while (index !== -1) {
        index = this.findIndex(array, value, key, startIndex);
        if (index !== -1) {
          array.splice(index, 1);
        }
      }
    },
    toggle(array, value, key) {
      if (this.exist(array, value, key)) {
        this.remove(array, value, key);
      } else {
        array.push(value);
      }
    },
    toggleArray(array, part, key) {
      if (this.existArray(array, part, key)) {
        part.forEach(value => this.remove(array, value, key));
      } else {
        part.forEach(value => this.unipush(array, value, key));
      }
    },
    concat(array, part, index) {
      if (utils.isUndefined(index)) {
        index = array.length;
      }
      array.splice(index, 0, ...(utils.isArray(part) ? part : [part]));
    },
    toMatrix(array, rows, cols) {
      const matrix = [];
      for (let i = 0; i < rows; i += 1) {
        matrix[i] = [];
        for (let j = 0; j < cols; j += 1) {
          matrix[i][j] = array[i * cols + j];
        }
      }
      return matrix;
    },
    getArrEqual(arr1, arr2) {
      let newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    getArrRepeatNumber(array, value, key) {
      let number = 0;
      for (let i = 0; i < array.length; i += 1) {
        if (array[i][key] === value[key]) {
          number += 1;
        }
      }
      return number;
    },
    sum(numbers) {
      return numbers.reduce((total, num) => (total + num));
    },
  },
  Date: {
    format(date, formatExp) {
      let result = formatExp;
      if (utils.isDate(date)) {
        const years = String(date.getFullYear());
        const months = date.getMonth() + 1;
        const days = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const milliseconds = date.getMilliseconds();
        const spans = [
          {
            key: 'yyyy',
            value: years,
          },
          {
            key: 'yy',
            value: years.substr(-2),
          },
          {
            key: 'MM',
            value: utils.leftPad(months, '0', 2),
          },
          {
            key: 'M',
            value: months,
          },
          {
            key: 'dd',
            value: utils.leftPad(days, '0', 2),
          },
          {
            key: 'd',
            value: days,
          },
          {
            key: 'HH',
            value: utils.leftPad(hours, '0', 2),
          },
          {
            key: 'H',
            value: hours,
          },
          {
            key: 'mm',
            value: utils.leftPad(minutes, '0', 2),
          },
          {
            key: 'm',
            value: minutes,
          },
          {
            key: 'ss',
            value: utils.leftPad(seconds, '0', 2),
          },
          {
            key: 's',
            value: seconds,
          },
          {
            key: 'S',
            value: utils.leftPad(milliseconds, '0', 3),
          },
        ];
        for (let i = 0; i < spans.length; i += 1) {
          const span = spans[i];
          result = result.replace(new RegExp(span.key, 'g'), span.value);
        }
      }
      return result;
    },
  },
  closeWindow() {
    /* eslint-disable */
    if (WeixinJSBridge && WeixinJSBridge.invoke) {
      WeixinJSBridge.invoke('closeWindow', {}, window);
    }
  },
  pay({ appId, timestamp, nonceStr, pkg, paySign, signType }) {
    const _wx = wx;
    return new Promise(((resolve, reject) => {
      _wx.chooseWXPay({
        appId,
        timestamp,
        nonceStr: nonceStr,
        package: pkg,
        paySign,
        signType,
        success: (res) => {
          resolve(res);
        },
        cancel: function (res) {
          resolve(res);
        },
        fail: (err) => {
          reject(err);
        },
      });
    }));
  },
  noop() {
  },
  storage(key, data) {
    /* eslint-disable */
    const localStorage = window.localStorage;
    if (typeof data === 'undefined') {
      const value = localStorage.getItem(key);
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    } else {
      if (data !== null) {
        localStorage.setItem(key, this.isString(data) ? data : JSON.stringify(data));
      } else {
        localStorage.removeItem(key);
      }
    }
    return null;
  },
  log: window.console.log.bind(window),
  redirect(url) {
    window.location.href = url;
    // window.history.back(window.location.href = url);
  },
  title(title) {
    document.title = title;
  },
  login(token) {
    utils.storage('token', token);
    axios.defaults.headers.common['Authorization'] = token;
  },
  params(key) {
    const params = {};

    const query = window.location.href;
    const rParam = /[?&]([^=&]+)(?:=([^&]*))?/g;
    let hits;
    let k;
    let v;
    /* eslint-disable */
    while (hits = rParam.exec(query)) {
      [, k, v] = hits;
      params[k] = v ? decodeURIComponent(v) : null;
    }

    if (key) {
      if (key in params) {
        return params[key];
      }
      return undefined;
    }
    return params;
  },
  clone(data) {
    if (this.isObject(data)) {
      return JSON.parse(JSON.stringify(data));
    } else {
      return data;
    }
  },
  jsonify(obj) {
    const clone = {};
    if (obj) {
      Object.keys(obj).forEach((key) => {
        if (utils.isObject(obj[key]) || utils.isArray(obj[key])) {
          clone[key] = JSON.stringify(obj[key]);
        } else {
          clone[key] = obj[key];
        }
      });
    }
    return clone;
  },
  leftPad(value, pad, length) {
    value = String(value);
    while (value.length < length) {
      value = pad + value;
    }
    return value;
  },
  querystring(json) {
    if (!json) return '';
    return Object.keys(json).map(key => {
      if (json[key] === undefined) return '';
      return encodeURIComponent(key) + '=' +
        encodeURIComponent(json[key]);
    }).join('&');
  },
  secondsToTime(totalSeconds) {
    let time = '';
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    seconds = totalSeconds;

    hours = Math.floor(seconds / (60 * 60));
    if (hours) {
      seconds = seconds % (60 * 60);
    }
    minutes = Math.floor(seconds / 60);
    if (minutes) {
      seconds = seconds % 60;
    }

    if (hours) {
      if (hours < 10) {
        time = '0';
      }
      time += hours;
      time += ':';
    }
    if (minutes < 10) {
      time += '0';
    }
    time += minutes;
    time += ':';
    if (seconds < 10) {
      time += '0';
    }
    time += seconds;

    return time;
  },
  getApiPath(url) {
    // 运维调整了跨域策略，统一改为同域调用接口（2020.4.3）
    // if (/^\/api\//i.test(url)) {
    //   /* eslint-disable */
    //   const host = window.location.host;
    //   if (/^teacher\.wx\.xxzx\.vip$/i.test(host)) {
    //     return `https://www.xxzx.vip${url}`;
    //   } else if (/^test\.passion\.vanthink\.cn$/i.test(host)) {
    //     return `https://test.xuexi.vanthink.cn${url}`;
    //   } else if (/^dev\.passionteacher\.wx\.vanthink\.cn$/i.test(host)) {
    //     return `https://dev.passion.vanthink.cn${url}`;
    //   }
    // }
    return url;
  },
  get(url, params, loading, disableTopTip) {
    let options = {};
    let loadingInstance;

    if (utils.isObject(params)) {
      if ('params' in params) {
        options = params;
        params = options.params;
      } else {
        options.params = params;
      }
      options.params = utils.jsonify(options.params);
    } else if (params) {
      loading = params;
    } else {
      loading = false;
    }
    if (loading) {
      loadingInstance = utils.loading(loading);
    }

    if (!options.params) {
      options.params = {};
    }
    // if (!options.params.openid) {
    //   options.params.openid = utils.Cookie.get('openid');
    // }
    return new Promise((resolve, reject) => {
      Vue
        .http
        .get(utils.getApiPath(url), options)
        .then(res => {
          if (loadingInstance) {
            loadingInstance.hide();
          }
          if (res.headers['x-redirect-to']) {
            utils.redirect(res.headers['x-redirect-to']);
          }
          if (res.data.code) {
            if (res.data.code === 44) {
              utils.storage('token', null);
              utils.redirect(`${location.origin}/#/login?back=1`);
            }
            if (!disableTopTip) {
              utils.topTips(res.data.message);
            }
            reject(res.data);
          } else if (utils.isUndefined(res.data.code)) {
            utils.topTips('系统繁忙，请稍后重试');

            reject(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(() => {
          if (loadingInstance) {
            loadingInstance.hide();
          }
          utils.topTips('系统繁忙，请稍后重试');

          reject();
        });
    });
  },
  post(url, data, loading, disableTopTip = true) {
    let options = {};
    let loadingInstance;

    if (utils.isObject(data)) {
      if ('data' in data) {
        options = data;
        data = options.data;
      }
      data = utils.jsonify(data);
    } else if (data) {
      loading = data;
      data = null;
    } else {
      loading = false;
      data = null;
    }
    if (loading) {
      loadingInstance = utils.loading(loading);
    }

    if (!data) {
      data = {};
    }
    // if (!data.openid) {
    //   data.openid = utils.Cookie.get('openid');
    // }

    return new Promise((resolve, reject) => {
      Vue
        .http
        .post(utils.getApiPath(url), data, options)
        .then(res => {
          if (loadingInstance) {
            loadingInstance.hide();
          }
          if (res.headers['x-redirect-to']) {
            utils.redirect(res.headers['x-redirect-to']);
          }
          if (res.data.code) {
            if (res.data.code === 44) {
              utils.storage('token', null);
              utils.redirect(`${location.origin}/#/login?back=1`);
            }
            if (disableTopTip) {
              utils.topTips(res.data.message);
            }
            reject(res.data);
          } else if (utils.isUndefined(res.data.code)) {
            utils.topTips('系统繁忙，请稍后重试');

            reject(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(() => {
          if (loadingInstance) {
            loadingInstance.hide();
          }
          utils.topTips('系统繁忙，请稍后重试');

          reject();
        });
    });
  },
  error(msg, stack) {
    Vue.http.get('/front-error-log', {
      params: {
        message: msg,
        stack: stack,
      },
    });
  },
  debounce(fn, delay) {
    // 维护一个 timer
    let timer = null;

    return function () {
      // 通过 ‘this’ 和 ‘arguments’ 获取函数的作用域和变量
      let context = this;
      let args = arguments;

      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    }
  },
  backToTop() {
    window.scrollTo(0, 0);
  },
  isUndefined(value) {
    return typeof value === 'undefined';
  },
  isBoolean(value) {
    return typeof value === 'boolean';
  },
  isObject(value) {
    return value !== null && typeof value === 'object';
  },
  isFunction(value) {
    return typeof value === 'function';
  },
  isString(value) {
    return typeof value === 'string';
  },
  isArray(value) {
    return Array.isArray(value);
  },
  isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
  },
};

export default utils;



// WEBPACK FOOTER //
// ./src/services/utils.js